// extracted by mini-css-extract-plugin
export default {"container":"CollapsibleSnackBar_container__ukC0V","icon":"CollapsibleSnackBar_icon__Xsl5g","content":"CollapsibleSnackBar_content__jxU24","close":"CollapsibleSnackBar_close__xYrYm"};